import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { Dropdown } from 'react-native-element-dropdown';
import { TextSmallSize } from '../../constants/Fonts';

// Omit props from the inferred Dropdown props that are handled manually by SelectProps
type CustomSelectProps = Omit<
  React.ComponentProps<typeof Dropdown>,
  'data' | 'value' | 'onChange' | 'labelField' | 'valueField' | 'style' | 'containerStyle' | 'renderItem' | 'selectedTextStyle'
>;

interface SelectProps extends CustomSelectProps {
  label: string;
  options: any[];
  value: any;
  onChange: (value: any, selectedObj: any) => void;
  labelField?: string;
  valueField?: string;
  customStyle?: {
    container?: any;
    label?: any;
    input?: any;
    optionsContainer?: any;
    renderItemContainer?: any;
    renderItemText?: any;
    selectedTextStyle?: any;
  };
  renderItem?: (item: any) => React.ReactElement;
}

const Separator = () => <View style={styles.separator} />;

const Select: React.FC<SelectProps> = ({
  label,
  options,
  value,
  onChange,
  labelField = 'label',
  valueField = 'value',
  customStyle = {},
  renderItem: customRenderItem,
  ...rest
}) => {
  const defaultRenderItem = (item: any) => (
    <View style={[styles.renderItemContainer, customStyle.renderItemContainer]}>
      <Text style={[styles.renderItemText, customStyle.renderItemText]}>{item[labelField]}</Text>
    </View>
  );

  const renderItem = customRenderItem || defaultRenderItem;

  return (
    <View style={customStyle.container}>
      {label && <Text style={[styles.label, customStyle.label]}>{label}</Text>}
      <Dropdown
        style={[styles.input, customStyle.input]}
        containerStyle={[styles.optionsContainer, customStyle.optionsContainer]}
        selectedTextStyle={[styles.selectedTextStyle, customStyle.selectedTextStyle]}
        renderItem={renderItem}
        flatListProps={{
          ItemSeparatorComponent: Separator,
        }}
        data={options}
        labelField={labelField}
        valueField={valueField}
        value={value}
        onChange={(item: any) => {
          onChange(item[valueField], item);
        }}
        {...rest}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  label: {
    color: '#555555',
    fontSize: TextSmallSize,
  },
  input: {
    minHeight: 40,
    borderColor: 'gray',
    borderWidth: 1,
    borderRadius: 0,
    marginTop: 4,
    marginBottom: 10,
    padding: 10,
    paddingHorizontal: 8,
  },
  optionsContainer: {
    backgroundColor: '#fff',
    borderWidth: 1,
    borderColor: 'gray',
    borderRadius: 0,
  },
  renderItemContainer: {
    padding: 12,
  },
  renderItemText: {
    color: '#333333',
    fontSize: TextSmallSize,
  },
  selectedTextStyle: {
    color: '#000000',
    fontSize: TextSmallSize,
  },
  separator: {
    height: 1,
    backgroundColor: '#c5c5c5',
  },
});

export default Select;